/**
 * Agora theme JavaScript entry point.
 *
 * SCSS wordt geïmporteerd zodat Vite hem via de JavaScript dependency
 * graph verwerkt. Dit geeft werkende CSS sourcemaps tijdens development,
 * wat niet mogelijk is als SCSS als losse entry in `rollupOptions.input`
 * staat.
 *
 * Deze bundle is **deferred** — laadt na render-blocking resources. Hij
 * bevat alleen functionaliteit die pas bij user-interactie (scroll,
 * klik, navigatie) nodig is. UI-critical modules (custom selects,
 * close-button hover) staan in `ui.js`, die zonder defer laadt zodat
 * visuele enhancements al staan voor de pagina visible is.
 */

import '../scss/main.scss';

import { initArchiveUrl } from './modules/archive-url.js';
import { initCloseButtonHover } from './modules/ui/close-button-hover.js';
import { initMobileNav } from './modules/ui/mobile-nav.js';
import { initNavSubmenu } from './modules/ui/nav-submenu.js';
import { initStickyHeader } from './modules/ui/sticky-header.js';

/**
 * Bootstrap deferred functionaliteit. UI-critical modules
 * (`initCustomSelects`, `initCloseButtonHover`) zitten in `ui.js` en
 * draaien onafhankelijk — `initArchiveUrl` werkt nog steeds met de
 * al-enhanced native selects via change-event mirror.
 *
 * Graceful degradation: op pagina's zonder filter/sort forms doet
 * `initArchiveUrl` niets; zonder mobile-toggle doet `initMobileNav`
 * niets.
 */
function bootstrap() {
    initArchiveUrl();
    initMobileNav();
    initNavSubmenu();
    initStickyHeader();
    initCloseButtonHover();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
} else {
    bootstrap();
}
